import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import extractDialogProps from 'components/extractDialogProps';

export default function AlertDialog(props) {
  const [dialogProps] = extractDialogProps(props);

  const {
      handleClose,
  } = props;

  return (
    <div>
      <Dialog
        {...dialogProps}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {props.title ? (<DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>) : null}
        {props.message ?
        (<DialogContent>
          <DialogContentText id="alert-dialog-description">
            {props.message}
          </DialogContentText>
        </DialogContent>) : null
        }
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            確認
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}